import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css``

const developerCSS = css``

export const DepositPanelCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
export const CopyIcon = styled(IconLib).attrs({ dimension: '16px' })`
  position: absolute;
  right: 15px;
  margin: 0 0 0 10px;
`
